import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconVoiceCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVoiceCircle"><Path d="M3.19043 14.6428C12.4404 -1.65477 13.6066 23.798 20.8095 14.6428" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M4 16.5C9.62041 12.4518 12.7295 20.141 17.7262 19.2731" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconVoiceCircle;
